import {$, T} from "../../common/drupal/drupal";

class ParagraphCarrousel {
	
	/**
	 * Initialize event listeners
	 */
	init () {
		// slide Paragraph carrousel
		let carrouselId = 0;
		let carrousels = [];
		$('.ParagraphCarrousel-slides').each(function () {
			if($(this).find('.swiper-wrapper').length < 1) {
				$(this).addClass('swiper-container').find('.ParagraphSlide').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');
				$(this).append('<div class="swiper-button-prev swiper-button-prev-carrousel swiper-button-prev-carrousel-' + carrouselId + '""></div><div class="swiper-button-next swiper-button-next-carrousel swiper-button-next-carrousel-' + carrouselId + '""></div>');
				carrousels[carrouselId] = new Swiper($(this), {
					slidesPerView: 'auto',
					speed: 1000,
					centerInsufficientSlides: true,
					watchOverflow: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				});
				carrouselId++;
			}
		});
	}
	
	attach(context) {
		this.init(context);
	}
}

export let paragraphCarrousel = new ParagraphCarrousel();
